import { render } from "./TicketCard.vue?vue&type=template&id=c84dd314&scoped=true"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"

import "./TicketCard.vue?vue&type=style&index=0&id=c84dd314&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84dd314"]])

export default __exports__